export default "__VITE_ASSET__Co7hL6RN__"